module.exports = __webpack_public_path__ + "static/media/100.401de91c.svg";